export default {
  init() {






    $('.header__item').on('click', () => {
     // e.stopPropagation();
    });

    /*************************
    * Open Menu
    * ************************/
   /*
    $('.header__link').on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      window.scrollTo(0, 0);

      var $headerListItem = $(e.currentTarget).parent('.header__item');

      if( this.isClosed($headerListItem) ) {

        this.closeAllMenus();

        this.openMenu($headerListItem);

      } else {
        // remove open menus
        this.closeAllMenus();
      }
    });
    */

    /*************************
    * Close Menu on body click
    * ************************/
    $('body').on('click', () => {
      if(! this.isClosed($('.header__item')) ){
        this.closeAllMenus();
      }
    });

    /****************************
    * Close Menu on close button
    * ***************************/
    $('.close-button-menu').on('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      this.closeAllMenus();
    });
  },

  closeAllMenus() {
    $('.header__item').removeClass('header__item--active');
    $('.header').removeClass('header--open');
    $('body').removeClass('header--is-visible');
    $('.header__list--child .header__item').removeClass('stagger');
  },

  isClosed($el) {
    return !$el.hasClass('header__item--active');
  },

  openMenu($el) {

    if( $(window).width() > 867) {
      if($('.burger').hasClass('burger--closed')) {
        $('.burger').trigger('click');
      }
    }

    $el.addClass('header__item--active');
    $('.header').addClass('header--open');
    $('body').addClass('header--is-visible');
    $('.header__list--child .header__item').removeClass('stagger');

    setTimeout(function() {
      $('.header__list--child .header__item').addClass('stagger');
    }, 100);

  },
}



// WEBPACK FOOTER //
// ./scripts/modules/menu.js